import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'mobile-contact',
  templateUrl: './mobile-contact.component.html',
  styleUrls: []
})
export class MobileContactComponent implements OnInit {
  darkMode = false;
  loading = false;
  contactForm: FormGroup;
  nameValid: boolean = true;
  mailValid: boolean = true;
  phoneValid: boolean = true;
  messageValid: boolean = true;
  formValid: boolean = false;

  constructor(private route: ActivatedRoute, private http: HttpClient) {
    try {
      const mode = this.route.snapshot.queryParams["mode"];
      this.darkMode = mode === "0" || mode === 0;
      const darkClass = this.darkMode ? "dark" : "";
      document.documentElement.className = darkClass;
      document.body.className = darkClass;
    } catch (e) {
    }
    window.scrollTo(0, 0);
    this.contactForm = new FormGroup({
      company: new FormControl(),
      name: new FormControl('', [
        Validators.required,
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
      ]),
      phone: new FormControl('', [
        Validators.required,
      ]),
      message: new FormControl('', [
        Validators.required,
      ])
    });
  }
  ngOnInit() {
    this.prefillFromQueryParams();
  }
  private prefillFromQueryParams() {
    const q = this.route.snapshot.queryParams;
    const company = q["company"];
    const nameParam = q["name"];
    const surname = q["surname"];
    const email = q["email"];
    const phone = q["phone"];
    const fullName = [nameParam, surname].filter(Boolean).join(" ").trim();
    if (company) this.contactForm.patchValue({ company });
    if (fullName) this.contactForm.patchValue({ name: fullName });
    if (email) this.contactForm.patchValue({ email });
    if (phone) this.contactForm.patchValue({ phone });
  }
  onSubmit() {
    this.loading = true;
    if (!this.contactForm.controls['name'].valid) {
      this.nameValid = false;
    } else this.nameValid = true;

    if (!this.contactForm.controls['email'].valid) {
      this.mailValid = false;
    } else this.mailValid = true;

    if (!this.contactForm.controls['phone'].valid) {
      this.phoneValid = false;
    } else this.phoneValid = true;

    if (!this.contactForm.controls['message'].valid) {
      this.messageValid = false;
    } else this.messageValid = true;

    if (this.nameValid && this.mailValid && this.phoneValid && this.messageValid)
      this.saveInfo();
    else this.loading = false;
  }
  checkPhone() {
    if (this.contactForm.controls["phone"].value[0] == '0')
      this.contactForm.controls["phone"].setValue(this.contactForm.controls["phone"].value.substr(1));
  }
  saveInfo() {
    let url = environment.notificationUrl + "/v1/notifications/email"
    let raw = this.contactForm.getRawValue();
    let req = {
      subject: "(APP) İletişim Başvurusu",
      params: {
        "Şirket Adı": raw.company,
        "Ad Soyad": raw.name,
        "E-Posta": raw.email,
        "Telefon": raw.phone,
        "Mesaj": raw.message
      }
    };
    this.http
      .post(url, req)
      .subscribe(
        responseData => {
          this.loading = false;
          this.formValid = true;
        },
        error => {
          this.loading = false;
          this.formValid = true;
        }
      );
  }
}
